import { gql } from './graphql';
export async function checkEmailAccount(email) {
    const data = await gql(`mutation CheckEmailAccount($email: String!) {
       checkEmailAccount(email: $email) { type organisationID }
     }`, { email }, { anonymous: true });
    return data.checkEmailAccount;
}
